import { useState } from "react";
import { faqs } from "@/mocks/homeContent";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <SectionHeading
          eyebrow="常见问题"
          title="关于最新地址与访问的常见疑问"
          desc="下面整理了用户最常问到的几个问题，点击任意一项即可展开查看完整回答。"
          align="center"
        />

        <div className="mx-auto mt-10 max-w-3xl space-y-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className={
                  open
                    ? "overflow-hidden rounded-lg border border-primary-300 bg-primary-50"
                    : "overflow-hidden rounded-lg border border-background-200 bg-background-100/70"
                }
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-2.5 font-heading text-base font-bold text-foreground-950">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-500 font-label text-xs font-bold text-background-50">
                      Q
                    </span>
                    {item.q}
                  </span>
                  <span className="flex h-6 w-6 shrink-0 items-center justify-center text-foreground-500">
                    <i className={open ? "ri-subtract-line text-lg" : "ri-add-line text-lg"}></i>
                  </span>
                </button>
                {open ? (
                  <div className="px-5 pb-5 pl-14">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}